import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaSpaceShuttle, FaChartBar, FaDollarSign, FaBalanceScale, FaTools, FaSync, FaDownload, FaBars } from 'react-icons/fa';
import './Navigation.css';
import { authService } from '../../services/authService';

interface NavigationProps {
  onCompareToggle?: () => void;
  isCompareMode?: boolean;
  compareCount?: number;
  showCompareButton?: boolean;
  onUpdateCatalog?: () => void;
  isUpdating?: boolean;
  disableCompare?: boolean;
  onExportFleetViewer?: () => void;
  onExportFleetStarjump?: () => void;
  showExportButton?: boolean;
  exportCount?: number;
  isMenuOpen?: boolean;
  onCloseMenu?: () => void;
}

export const Navigation: React.FC<NavigationProps> = ({
  onCompareToggle = () => {},
  isCompareMode = false,
  compareCount = 0,
  showCompareButton = false,
  onUpdateCatalog,
  isUpdating = false,
  disableCompare = false,
  onExportFleetViewer,
  onExportFleetStarjump,
  showExportButton = false,
  exportCount = 0,
  isMenuOpen = false,
  onCloseMenu = () => {}
}) => {
  const location = useLocation();
  const userData = authService.getUserData();
  const isAdmin = userData?.admin === true;


  return (
    <div className="nav-buttons">
      {/* Botón hamburguesa para móvil */}
      <button 
        className="hamburger-button"
        onClick={() => {}}
        title="Menú de navegación"
        style={{ display: 'none' }}
      >
        <FaBars />
      </button>

      {/* Menú de navegación */}
      <div className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
        <Link 
          to="/flota" 
          className={`nav-button ${location.pathname === '/flota' ? 'active' : ''}`}
          title="Gestiona tu flota"
          data-tutorial-target="fleet-button"
          onClick={onCloseMenu}
        >
          <FaSpaceShuttle />
          Flota
        </Link>

        {location.pathname !== '/garage' && (
          <Link 
            to="/catalogo" 
            className={`nav-button ${location.pathname === '/catalogo' ? 'active' : ''}`}
            title="Añade nuevas naves a tu flota"
            data-tutorial-target="catalog-button"
            onClick={onCloseMenu}
          >
            <FaDollarSign />
            Catálogo
          </Link>
        )}

        <Link 
          to="/garage" 
          className={`nav-button ${location.pathname === '/garage' ? 'active' : ''}`}
          title="Gestiona tus naves, sus nombres y componentes"
          onClick={onCloseMenu}
        >
          <FaTools />
          Garage
        </Link>

        <Link 
          to="/stats" 
          className={`nav-button ${location.pathname === '/stats' ? 'active' : ''}`}
          onClick={onCloseMenu}
        >
          <FaChartBar />
          Estadísticas
        </Link>

        {(showCompareButton || location.pathname === '/garage') && (
          <button 
            className={`nav-button ${isCompareMode ? 'active' : ''} ${disableCompare ? 'disabled' : ''}`}
            onClick={disableCompare ? undefined : () => { onCompareToggle(); onCloseMenu(); }}
            disabled={disableCompare}
            title={disableCompare ? 'Comparación no disponible en esta página' : (isCompareMode ? 'Desactivar comparación' : 'Comparar naves')}
          >
            <FaBalanceScale />
            Comparar ({compareCount}/4)
          </button>
        )}

        {showExportButton && location.pathname === '/flota' && (
          <div className="nav-export-group">
            {onExportFleetViewer && (
              <button
                type="button"
                className="nav-button export-button"
                onClick={() => {
                  onExportFleetViewer();
                  onCloseMenu();
                }}
                title={`Exportar ${exportCount} naves (formato FleetViewer clásico)`}
              >
                <FaDownload />
                FleetViewer ({exportCount})
              </button>
            )}
            {onExportFleetStarjump && (
              <button
                type="button"
                className="nav-button export-button export-button--starjump"
                onClick={() => {
                  onExportFleetStarjump();
                  onCloseMenu();
                }}
                title={`Exportar flota filtrada (formato Starjump FleetViewer)`}
              >
                <FaDownload />
                Starjump ({exportCount})
              </button>
            )}
          </div>
        )}

        {isAdmin && location.pathname === '/catalogo' && onUpdateCatalog && (
          <button 
            className={`nav-button update-button ${isUpdating ? 'updating' : ''}`}
            onClick={() => { onUpdateCatalog(); onCloseMenu(); }}
            disabled={isUpdating}
          >
            <FaSync className={isUpdating ? 'rotating' : ''} />
            {isUpdating ? 'Actualizando...' : 'Actualizar Catálogo'}
          </button>
        )}
      </div>
    </div>
  );
}; 